import React from 'react';
import * as T from 'prop-types';
import Typography from '../../common/Typography';

const styles = `
  h1,h2 {
    font-size: 20px;
    margin: 0;
    font-weight: normal;
  }
  h2 {
    font-size: 15px;
  }
  .invoice-container {
    max-width: 800px;
    margin: auto;
    text-align: center;
    color: grey;
    font-family: 'Roboto', Arial, sans-serif;
  }
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .modal-content {
    background: white;
    padding: 20px;
    border-radius: 5px;
    max-width: 600px;
    width: 90%;
    position: relative;
    max-height: 80vh;
    overflow-y: auto;
  }
  .scrollable-content {
    max-height: 70vh;
    overflow-y: auto;
    padding-right: 10px;
  }
  .close-button {
    position: absolute;
    top: 10px;
    right: 10px;
    font-size: 20px;
    cursor: pointer;
    background: none;
    border: none;
  }
  .invoice-details {
    text-align: left;
    font-size: 12px;
  }
  .invoice-table {
    font-size: 12px;
    width: 100%;
    border-collapse: collapse;
    border: 2px solid #ccc;
  }
  .invoice-table th, .invoice-table td {
    border: 1px solid #ccc;
    padding: 8px;
    text-align: left;
  }
  .invoice-table th {
    background-color:rgb(130, 121, 121);
    color: white;
  }
  .invoice-table td {
    background-color: rgb(255, 255, 255);
  }
  .bold {
    font-weight: bold;
  }
  .show-invoice-button {
    padding: 10px 15px;
    background: #007bff;
    color: white;
    border: none;
    cursor: pointer;
    font-size: 16px;
    border-radius: 5px;
  }
  .show-invoice-button:hover {
    background: #0056b3;
  }
  .sidebarLogo {
    height: 15px;
    margin-left: 4px;
    width: 20px;
    margin-top: 2px;
  }
`;

class PdfViewerModal extends React.PureComponent {
    constructor(props) {
        super(props);
        this.viewerRef = React.createRef();
    }

    static propTypes = {
        pdfUrl: T.string.isRequired,
        onClose: T.func.isRequired,
    };

    render() {
        const { onClose, item } = this.props;
        const subTotal = parseFloat((item.consultingServiceHours * item.consultingServicePrice).toFixed(2)) + parseFloat((item.travelExpenseHours * item.travelExpensePrice).toFixed(2)) + parseFloat((item.onsiteMeetingHours * item.onsiteMeetingPrice).toFixed(2));
        const discount = subTotal * item.discountPercentage / 100;
        const subTotalAfterDiscount = parseFloat(subTotal - discount);
        const serviceFee = subTotalAfterDiscount * 2 / 100;
        const lateFee = subTotalAfterDiscount * 2 / 100;
        const subTotalAfterFees = subTotalAfterDiscount + serviceFee + lateFee;
        const tax = subTotalAfterFees * item.taxPercentage / 100;
        const total = subTotalAfterFees + tax;

        return (
            <div onClose={onClose} className="invoice-container">
                <Typography variant="h4">PDF Viewer</Typography>
                <div className="modal-overlay">
                    <div className="modal-content modal-center">
                        <button className="close-button" onClick={onClose}>×</button>
                        <div className="text-center mb-6">
                            <img style={{ width: "50px" }} src="/images/prosofttools.png" alt="ProSoftTools" />
                            <h1 className="invoice-title">Professional Software Tools</h1>
                            <h2 className="invoice-subtitle">DAILY INVOICE</h2>
                            <hr />
                        </div>
                        <div className="invoice-details">
                            <p>
                                Invoice Number: {item.invoiceNumber}<br />
                                Invoice Date: {item.invoiceDate}<br />
                                Due Date: {item.dueDate}<br />
                                Project/Job ID: {item.projectId}<br />
                            </p>
                        </div>
                        <div className="invoice-details">
                            <p>
                                Billed To:<br />
                                Lannett Company<br />
                                Attn: Accounts Payable<br />
                                1150 Northbrook Dr<br />
                                Trevose, PA 19053<br />
                            </p>
                        </div>
                        <table className="invoice-table">
                            <thead>
                                <tr>
                                    <th>Item/Service</th>
                                    <th>Description</th>
                                    <th>Quantity</th>
                                    <th>Unit Price</th>
                                    <th>Line Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Consulting Services</td>
                                    <td>Strategic planning session (market analysis)</td>
                                    <td>{item.consultingServiceHours} Hours</td>
                                    <td>${Math.round(item.consultingServicePrice)}/hour</td>
                                    <td>${(item.consultingServiceHours * item.consultingServicePrice).toFixed(2)}</td>
                                </tr>
                                <tr>
                                    <td>Travel Expenses</td>
                                    <td>Round-trip airfare and local transportation</td>
                                    <td>{item.travelExpenseHours}</td>
                                    <td>${item.travelExpensePrice}</td>
                                    <td>${(item.travelExpenseHours * item.travelExpensePrice).toFixed(2)}</td>
                                </tr>
                                <tr>
                                    <td>On-site Meeting</td>
                                    <td>Refreshments & meeting materials</td>
                                    <td>{item.onsiteMeetingHours}</td>
                                    <td>${Math.round(item.onsiteMeetingPrice)}</td>
                                    <td>${(item.onsiteMeetingHours * item.onsiteMeetingPrice).toFixed(2)}</td>
                                </tr>
                                <tr className="bold">
                                    <td colSpan="4">Subtotal</td>
                                    <td>${subTotal.toFixed(2)}</td>
                                </tr>
                                <tr>
                                    <td colSpan="4">Discount ({item.discountPercentage}%)</td>
                                    <td>-${discount.toFixed(2)}</td>
                                </tr>
                                <tr className="bold">
                                    <td colSpan="4">Subtotal</td>
                                    <td>${subTotalAfterDiscount.toFixed(2)}</td>
                                </tr>
                                <tr>
                                    <td colSpan="4">Service Fee (2%)</td>
                                    <td>${serviceFee.toFixed(2)}</td>
                                </tr>
                                <tr>
                                    <td colSpan="4">Late Fee (2%)</td>
                                    <td>${serviceFee.toFixed(2)}</td>
                                </tr>
                                <tr className="bold">
                                    <td colSpan="4">Subtotal</td>
                                    <td>${subTotalAfterFees.toFixed(2)}</td>
                                </tr>
                                <tr>
                                    <td colSpan="4">Tax ({item.taxPercentage}%)</td>
                                    <td>${tax.toFixed(2)}</td>
                                </tr>
                                <tr className="bold">
                                    <td colSpan="4">Total Due</td>
                                    <td>${total.toFixed(2)}</td>
                                </tr>
                            </tbody>
                        </table>
                        <div className="invoice-details">
                            <p>
                                Additional Invoice Details:<br />
                                Service Date: {item.serviceDate}<br />
                                Time of Service: 09:00 AM – 05:00 PM<br />
                                Location: Lannett Company Headquarters<br />
                                Notes: Consulting included market trend analysis. Travel receipts attached.<br />
                                On-site meeting expenses include refreshments and printed materials.<br />
                            </p>
                        </div>
                        <div className="invoice-details">
                            <p>
                                Payment Instructions:<br />
                                - Payment Due By: {item.paymentDueDate}<br />
                                - Bank Transfer: Business Bank, A/C No: 733458901, Routing No: 1102234<br />
                                - Or via Check payable to Professional Software Tools<br />
                                Include Invoice Number {item.invoiceNumber} with your payment.<br />
                            </p>
                        </div>
                        <div className="invoice-details">
                            <p>
                                Terms & Conditions:<br />
                                Payment is due within 5 business days. Late payments may incur a 2% fee per month.<br />
                                Services are subject to our standard terms as per contract.<br />
                            </p>
                        </div>
                        <div className="invoice-details">
                            <p>
                                Contact Information:<br />
                                Email: admin@prosofttools.com<br />
                            </p>
                            <span style={{ float: "right", marginRight: "55px", marginTop: "0px"}}>Signature</span><br/>
                            <img style={{ width: "100px", float: "right", marginRight: "30px", marginTop: "10px"}} src="/images/signature.png" alt="Signature" />
                            <img style={{ width: "60px"}} src="/images/qr.png" alt="QR Code" />
                            <p>www.prosofttools.com</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default PdfViewerModal;

const styleSheet = document.createElement("style");
styleSheet.type = "text/css";
styleSheet.innerText = styles;
document.head.appendChild(styleSheet);